import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router} from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from "./shared/store/store";
import { AlertProvider } from "./shared/components/AlertProvider";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        {/* <PersistGate persistor={persistor} loading={null}> */}
            <Router>
                <AlertProvider>
                {/*<React.StrictMode>*/}
                    <App />
                {/*</React.StrictMode>*/}
                </AlertProvider>
                </Router>
        {/* </PersistGate> */}
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
